// Proteção contra conflitos de window.ethereum
// Alguns navegadores/extensões tentam redefini-lo

if (typeof window !== 'undefined') {
  // Apenas ignorar conflitos silenciosamente
  // Não tentar redefini-lo
  if (!window._ethereumFixed) {
    window._ethereumFixed = true;
  }
}

export {};
